import { SearchChartData } from 'redux/reducers/searchnFilterReducer';

export const chartConfigs = {
  title: {
    left: '2%', // Aligns to the left
    top: '2%', // Aligns to the top
    textStyle: {
      fontSize: 20, // Large font
      fontWeight: 'bold',
      color: '#333', // Optional: set your preferred color
    },
  },
  tooltip: {
    trigger: 'item',
    axisPointer: { type: 'shadow' },
    backgroundColor: 'rgba(10, 10, 10, 0.7)',
    borderColor: 'rgba(10, 10, 10, 0.7)',
    textStyle: { color: 'white' },
    formatter: function (params) {
      // If trigger is item, show tooltip for one stack only
      if (!Array.isArray(params)) {
        return `${params.marker} ${params.seriesName}: ${params.value}`;
      }

      // Filter out items with value <= 0
      const filtered = params.filter((p) => p.value > 0);
      // If no values, return empty string or "No data"
      if (filtered.length === 0) {
        return '';
      }

      // Build tooltip string
      let tooltip = `${filtered[0].axisValue}<br/>`;
      filtered.forEach((p) => {
        tooltip += `${p.marker}${p.seriesName} : ${p.value}<br/>`;
      });
      return tooltip;
    },
  },
  xAxis: {
    type: 'category',
    data: [],
    nameLocation: 'middle',
    nameGap: 40,
    nameTextStyle: {
      fontWeight: 'bold',
      fontSize: 14,
    },
  },
  yAxis: {
    type: 'value',
    nameLocation: 'middle',
    nameGap: 50,
    nameTextStyle: {
      fontWeight: 'bold',
      fontSize: 14,
    },
  },
  series: [],
  dataZoom: [
    {
      type: 'slider',
      show: true,
      xAxisIndex: [0],
      start: 0,
      end: 100,
      dataBackground: {
        lineStyle: { color: '#E0E0E0' },
        areaStyle: {
          color: '#E0E0E0',
          opacity: 1,
        },
      },
      selectedDataBackground: {
        lineStyle: { color: '#F7A246' },
        areaStyle: { color: '#F7A246', opacity: 0.5 },
      },
      borderColor: '#E0E0E0',
      fillerColor: 'rgba(247, 162, 70, 0.1)',
      handleStyle: { color: '#F7A246', borderColor: '#E0E0E0' },
      moveHandleStyle: { color: '#F7A246' },
      moveHandleSize: 4,
      emphasis: {
        moveHandleStyle: { color: '#F7A246' },
      },
    },
    {
      type: 'inside',
      xAxisIndex: [0],
      start: 0,
      end: 100,
    },
  ],
  legend: {
    type: 'plain',
    show: false,
    orient: 'vertical',
    right: '3%',
    top: '8%',
    itemWidth: 10,
    itemHeight: 10,
    textStyle: {
      fontSize: 10,
    },
  },
  grid: {
    bottom: '18%',
    right: '17%',
  },
};

export type useGetChartOptionsDataProps = {
  selectedChart: SearchChartData;
  binSize: number;
  isNumericChart: boolean;
};

export const NULL_VALUE_TITLE = 'None';

export const labelStyles = {
  value: {
    backgroundColor: '#fff',
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: 2,
    padding: [4, 4, 2, 4],
    color: '#000',
    fontSize: 12,
    lineHeight: 12,
  },
};
